import type { Page } from '../../types';

const fraudAgainstThePublic: Page[] = [
  {
    pageType: 'question',
    title: 'Fraud against the public',
    name: 'fraud-against-the-public-declare',
    questions: [
      {
        questionType: 'radio',
        title: 'Do you have any instances of fraud against the public to declare?',
        name: 'fraud_against_public_declare',
        options: ['Yes', 'No'],
        rules: { required: true },
      },
    ],
  },
  {
    pageType: 'question',
    title: 'Fraud against the public',
    name: 'fraud-against-the-public',
    type: 'nilreturn',
    fastToggle: true,
    total: {
      columns: [
        { title: 'Number of instances', field: 'fraud_against_public_instances' },
        { title: 'Total Value', field: 'fraud_against_public' },
      ],
    },
    disabled: [
      {
        field: 'fraud_against_public_declare',
        condition: 'equals',
        value: 'No',
      },
    ],
    questions: [
      {
        questionType: 'instanceInput',
        title: 'Total number of instances',
        name: 'fraud_against_public_instances',
        hint: '',
        rules: {
          required: true,
          decimal: 'decimal(2)',
        },
      },
      {
        questionType: 'costInput',
        displaySeperator: 'thousand',
        title: 'Estimated total value',
        name: 'fraud_against_public',
        hint: '',
        rules: {
          required: true,
          decimal: 'decimal(2)',
        },
      },
      {
        questionType: 'textarea',
        title: 'Comments',
        hideOptionalLabel: true,
        name: 'fraud_against_public_comments',
        hint: 'Please ensure you do not include any personal or sensitive information',
        rules: {
          required: false,
        },
      },
    ],
  },
];
export default fraudAgainstThePublic;




